import * as RSlider from "@radix-ui/react-slider";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/cn";

type SliderProps = ComponentPropsWithoutRef<typeof RSlider.Root>;

/**
 * Range slider used in Onboarding (target passive income) + LoanCalculator
 * (akontace %) + Insurance (coverage amount).
 */
export const Slider = forwardRef<HTMLDivElement, SliderProps>(
  ({ className, ...props }, ref) => (
    <RSlider.Root
      ref={ref}
      className={cn(
        "relative flex h-5 w-full touch-none select-none items-center",
        className,
      )}
      {...props}
    >
      <RSlider.Track className="relative h-1.5 grow rounded-full bg-bg-raised overflow-hidden">
        <RSlider.Range className="absolute h-full rounded-full bg-gradient-to-r from-amber to-coral" />
      </RSlider.Track>
      <RSlider.Thumb
        className={cn(
          "block h-4 w-4 rounded-full bg-amber border-2 border-[#1a1f2b]",
          "shadow-[0_2px_8px_rgba(245,178,99,0.5)]",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber",
          "transition-transform hover:scale-110",
        )}
      />
    </RSlider.Root>
  ),
);
Slider.displayName = "Slider";
